import { ReactNode } from 'react'
import cn from 'classnames'

import { Header } from '../Header'

import styles from './index.module.css'

type Props = {
  className?: string
  children: ReactNode
}

export const Container = ({ className, children, ...restProps }: Props) => {
  return (
    <>
      <Header />
      <div className={cn(styles.container, className)} {...restProps}>
        {children}
      </div>
    </>
  )
}
